import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core'
import { WelcomePackageService } from '../../welcome-package.service'
import { MatSort } from '@angular/material/sort'
import { LaunchDialogService } from '@spartacus/storefront'
import { Router, ActivatedRoute } from '@angular/router'
import { Location } from '@angular/common'
import { Observable } from 'rxjs'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { Actions } from '@ngrx/effects'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'

import { take } from 'rxjs/operators'
import {
  ACCESSIBILITY,
  UserRoleService,
} from '../../../../shared/services/user-role.service'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'
import { QuoteCartService } from '../../../quote/quote-services/quote-cart.service'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'
import { VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { QuoteCartFacade } from '../../../cart/mini-cart/store/mini-quote-cart.facade'
import moment from 'moment'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'

@Component({
  standalone: false,
  selector: 'vs-equipment-details',
  templateUrl: './equipment-details.component.html',
  styleUrls: ['./equipment-details.component.scss'],
})
export class EquipmentDetailsComponent implements OnInit {
  public selectedItem
  public tableData
  public tableData$: Observable<any>
  sortBy: any
  client: any = { indeterminated: false, checked: false }
  isMasterSel: boolean = false
  public selectedQuote = []
  public quoteUnavailable = []
  public showSuccess: boolean
  public showWarning: boolean
  public serialNo: string
  public partNo: string
  public partDescription: string
  public orderEntry: Array<any> = []
  public quoteEntrie: Array<any> = []
  public rfqCartId
  public inputQuantity = '1'
  public salesOrderRef
  public noData
  public successData
  crntPage = 0
  PAGE_SIZE = 50
  totalResult
  totalPages: any
  currentlyLoading: boolean = false
  isLoadMoreInProgress = false
  full: boolean = true
  displayedColumns: string[] = [
    'check box',
    //'Sales Order',
    'Part Number',
    'Description',
    'SparesIndicator',
    'Ordered Qty',
    'Recommended Qty',
    'Requested Ship Date',
    'cart',
    'receipt',
  ]
  public dataSource
  public quantity
  loading = true
  cartId$: Observable<any> = this.activeCartFacade.getActiveCartId()
  cartId
  public reasonForQuoteArray$: Observable<any>
  public reasonForQuotes
  accessibility = ACCESSIBILITY
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  public minDate = new Date()
  isAllRSDapply: boolean = false
  allRequestedShipDate: any

  constructor(
    private cdr: ChangeDetectorRef,
    private welcomePackageService: WelcomePackageService,
    protected launchDialogService: LaunchDialogService,
    private readonly activatedRoute: ActivatedRoute,
    private breadCrumbService: BreadcrumbService,
    private location: Location,
    private readonly router: Router,
    private multiCartFacade: MultiCartFacade,
    private activeCartFacade: ActiveCartFacade,
    private actions$: Actions,
    private globalMessageService: GlobalMessageService,
    private quoteService: QuoteCartService,
    private spinnerOverlayService: SpinnerOverlayService,
    private translate: TranslationService,
    private userRoleService: UserRoleService,
    private quoteCartFacade: QuoteCartFacade,
    private calenderConfigService: CalenderConfigService,
  ) {
    this.showSuccess = false
    this.showWarning = false
    this.noData = false
    // this.quantity= 1;
  }
  @ViewChild(MatSort) sort: MatSort

  ngOnInit(): void {
    this.translate
      .translate('welcomePackage.equipmentSearch')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadCrumbs([
          {
            label: res,
            link: '/welcome-package/serial-search',
          },
        ])
      )

    this.translate
      .translate('welcomePackage.equipmentDetails')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.partNo = sessionStorage.getItem('partNo')
    this.partDescription = sessionStorage.getItem('partDes')
    this.salesOrderRef = sessionStorage.getItem('salesOrder')
    //this.getBomData();
    this.activatedRoute.paramMap.subscribe((value: any) => {
      const id = value.params.id
      this.serialNo = id
      const recSource = value.params.recSource
      this.welcomePackageService.bomData(id, recSource)
      this.getBomData(this.crntPage, this.PAGE_SIZE)
    })
    this.activeCartFacade.getActiveCartId().subscribe((success) => {
      this.cartId = success
    })

    this.reasonForQuoteArray$ = this.quoteService.getQuoteReason('current')
    this.reasonForQuoteArray$.subscribe(
      (res) => {
        this.reasonForQuotes = res.reasonforQuote
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  public getBomData = function (currentPage, PAGE_SIZE) {
    this.tableData$ = this.welcomePackageService.getBomDetails(
      currentPage,
      PAGE_SIZE
    )
    this.tableData$.subscribe(
      (res) => {
        if(res?.status === 'success'){
          this.tableData = res
          this.dataSource = this.tableData?.serialNumberBOMSearchList
          this.totalResult = res?.serialNumberBOMSearchList?.length;
          for (
            let i = 0;
            i < this.tableData.serialNumberBOMSearchList.length;
            i++
          ) {
            this.dataSource[i]['quantity'] = this.dataSource[i]['bomQty']
            this.dataSource[i]['customerRequestedDate'] = ''
          }
          this.selectedItem = this.tableData.serialNumberHeaderInfo
        }
        else{
          this.noData = true
        }
      },
      (error) => {
        this.noData = true
      }
    )
  }

  dateChange(event, element) {   
    element.customerRequestedDate = moment(event).format('YYYY/MM/DD');
    this.cdr.detectChanges();
  }

  dateChangeAll(event) {
    this.allRequestedShipDate = moment(event).format('YYYY/MM/DD');    
    this.cdr.detectChanges();
    this.isAllRSDapply = false;
  }

  applyReqShipDateAll(){
    if(!this.allRequestedShipDate){
      this.isAllRSDapply = true;
      this.globalMessageService.add(
        { key: 'welcomePackage.selectCRDErrMsgAll' },
        GlobalMessageType.MSG_TYPE_ERROR,
        7000
      )
      window.scrollTo(0, 0)
    } else{
      this.isAllRSDapply = false;

      if(this.selectedQuote.length == 0){
        this.globalMessageService.add(
          { key: 'welcomePackage.productsSelectErrMsg' },
          GlobalMessageType.MSG_TYPE_ERROR,
          7000
        )
        window.scrollTo(0, 0)
      } else{
        this.selectedQuote.map((res)=> {
          res.customerRequestedDate = this.allRequestedShipDate;
        });
      }
    }
  }

  searchPrd() {
    this.location.back()
  }
  decreasing() {
    this.dataSource = [
      ...this.dataSource.sort(
        (a, b) => 0 - (a.sparesIndicator > b.sparesIndicator ? 1 : -1)
      ),
    ]
  }
  increasing() {
    this.dataSource = [
      ...this.dataSource.sort(
        (a, b) => 0 - (a.sparesIndicator < b.sparesIndicator ? 1 : -1)
      ),
    ]
  }
  decreaseQuantity(element) {
    if (typeof element.quantity == 'string') {
      element.quantity = parseInt(element.quantity) - 1
    } else {
      element.quantity = element.quantity - 1
    }
  }
  increaseQuantity(element) {
    if (element.quantity < 9999) {
      if (typeof element.quantity == 'string') {
        element.quantity = parseInt(element.quantity) + 1
      } else {
        element.quantity = element.quantity + 1
      }
    } else {
      element.quantity = '9999'
    }
  }
  updateCheckedOptions(event, element) {
    this.isMasterSel = false
    element.selected = event.target.checked
    if (event.target.checked) {
      this.selectedQuote.push(element)
      this.client.indeterminated = true
      this.client.checked = false
      if (this.selectedQuote.length > 0) {
        if (this.selectedQuote.length == this.dataSource.length) {
          this.client.indeterminated = false
          this.client.checked = true
          this.isMasterSel = true
        } else {
          this.client.indeterminated = true
          this.client.checked = false
        }
      } else {
        this.client.indeterminated = false
        this.client.checked = true
      }
    } else {
      const index = this.selectedQuote.indexOf(element)
      if (index > -1) {
        this.selectedQuote.splice(index, 1)
      }
      if (this.selectedQuote.length > 0) {
        this.client.indeterminated = true
        this.client.checked = false
      } else {
        this.client.indeterminated = false
        this.client.checked = false
      }
    }
  }

  buyQuote() {
    this.orderEntry = []
    if (this.selectedQuote.length == 0) {
      this.showWarning = true
      window.scrollTo(0, 0)
      this.showSuccess = false
      setTimeout(
        function () {
          this.showWarning = false
          this.showSuccess = false
        }.bind(this),
        5000
      )
    } else {
      this.quoteUnavailable = []
    }
    for (let i = 0; i < this.selectedQuote.length; i++) {
      let obj = {
        product: {
          code: this.selectedQuote[i].partNumber,
        },
        customerRequestedDate: this.selectedQuote[i].customerRequestedDate,
        quantity: this.selectedQuote[i].quantity,
        serialNumber: this.serialNo
      }

      if(obj.customerRequestedDate){
        this.orderEntry.push(obj);
      }
    }

    if(this.orderEntry.length === this.selectedQuote.length){
      this.spinnerOverlayService.show();
      this.welcomePackageService
      .addItemToCart({ orderEntries: this.orderEntry })
      .subscribe((res) => {
        this.spinnerOverlayService.hide()
        this.successData = res;
        sessionStorage.setItem('nonSellableProd', 'true');
        if (
          this.successData.nonCatalogProductList.length > 0 &&
          this.successData.cartModifications.length > 0
        ) {
          this.welcomePackageService.getQuoteUnavailabe(this.successData)
          const componentdata = {}
          const cartDialog = this.launchDialogService.openDialog(
            VS_LAUNCH_CALLER.CART_MODAL,
            undefined,
            undefined,
            componentdata
          )
          if (cartDialog) {
            cartDialog.pipe(take(1)).subscribe((value) => {})
            this.launchDialogService.dialogClose.subscribe((value) => {})
          }
          this.showSuccess = false
        } else if (this.successData.cartModifications.length > 0) {
          this.welcomePackageService.getQuoteUnavailabe(this.successData)
          const componentdata = {}
          const cartDialog = this.launchDialogService.openDialog(
            VS_LAUNCH_CALLER.CART_MODAL,
            undefined,
            undefined,
            componentdata
          )
          if (cartDialog) {
            cartDialog.pipe(take(1)).subscribe((value) => {})
            this.launchDialogService.dialogClose.subscribe((value) => {})
          }
          this.showSuccess = false
        } else {
          for (let i = 0; i < this.selectedQuote.length; i++) {
            this.selectedQuote[i].selected = false
            this.client.indeterminated = false
            this.client.checked = false
            this.quoteUnavailable.push(this.selectedQuote[i])
            if (
              this.successData.cartModifications.length == 0 &&
              this.quoteUnavailable.length == this.selectedQuote.length
            ) {
              this.showSuccess = true
              this.showWarning = false
              window.scrollTo(0, 0)
              setTimeout(
                function () {
                  this.showSuccess = false
                  this.showWarning = false
                }.bind(this),
                7000
              )
            }
          }
        }
        this.selectedQuote = []
        this.multiCartFacade.loadCart({
          userId: 'current',
          cartId: this.cartId,
          extraData: {
            active: true,
          },
        })
      })
    } else{
      this.spinnerOverlayService.hide();
      this.globalMessageService.add(
        { key: 'welcomePackage.selectAllCRDErrMsg' },
        GlobalMessageType.MSG_TYPE_ERROR,
        7000
      )
      window.scrollTo(0, 0);
    }
  }

  singleBuyQuote(element) {
    if(!element.customerRequestedDate){
      this.globalMessageService.add(
        { key: 'welcomePackage.selectCRDErrMsg' },
        GlobalMessageType.MSG_TYPE_ERROR,
        7000
      )
      window.scrollTo(0, 0);
    } else{
      this.quoteUnavailable = [];
      let obj = {
        orderEntries: [
          {
            product: {
              code: element.partNumber,
            },
            customerRequestedDate: element.customerRequestedDate,
            quantity: element.quantity,
            serialNumber: this.serialNo
          },
        ],
      }
      this.spinnerOverlayService.show()
      this.welcomePackageService.addItemToCart(obj).subscribe((res) => {
        this.spinnerOverlayService.hide()
        this.multiCartFacade.loadCart({
          userId: 'current',
          cartId: this.cartId,
          extraData: {
            active: true,
          },
        })
        this.successData = res;
        sessionStorage.setItem('nonSellableProd', 'true');
        if (
          this.successData.nonCatalogProductList.length > 0 &&
          this.successData.cartModifications.length == 0
        ) {
          this.quoteUnavailable.push(element)
          this.showSuccess = true
          this.showWarning = false
          window.scrollTo(0, 0)
          setTimeout(
            function () {
              this.showSuccess = false
              this.showWarning = false
            }.bind(this),
            7000
          )
        } else {
          this.welcomePackageService.getQuoteUnavailabe(this.successData)
          const componentdata = {}
          const cartDialog = this.launchDialogService.openDialog(
            VS_LAUNCH_CALLER.CART_MODAL,
            undefined,
            undefined,
            componentdata
          )
          if (cartDialog) {
            cartDialog.pipe(take(1)).subscribe((value) => {})
            this.launchDialogService.dialogClose.subscribe((value) => {})
          }
          this.showSuccess = false
        }
      })
    }
  }

  singleGetQuote(element) {
    if(!element.customerRequestedDate){
      this.globalMessageService.add(
        { key: 'welcomePackage.selectCRDErrMsg' },
        GlobalMessageType.MSG_TYPE_ERROR,
        7000
      )
      window.scrollTo(0, 0);
    } else{
      element.reasonForQuote = this.reasonForQuotes[0].code;
      const submitObj = {
        quoteEntryList: [
          {
            brandName: element.brandName,
            brandCode: element.brandCode,
            comment: '',
            customerRequestedDate: element.customerRequestedDate,
            rfqPartDescription: element.description,
            rfqPartNumber: element.partNumber,
            productType: 'Part',
            quantity: element.quantity,
            reasonForQuote: this.reasonForQuotes[0].code,
            serialNumber: this.serialNo,
            tagNumber: '',
          },
        ],
      }
      this.spinnerOverlayService.show();
      this.welcomePackageService.addItemToQuote(submitObj).subscribe((res) => {
        for (let i = 0; i < this.selectedQuote.length; i++) {
          this.selectedQuote[i].selected = false
          this.client.indeterminated = false
          this.client.checked = false
        }
        this.selectedQuote = []
        this.quoteEntrie = []
        sessionStorage.setItem('cartStatus-current', 'added')
        const componentdata = {}
        this.spinnerOverlayService.hide()
        const quoteDialog = this.launchDialogService.openDialog(
          VS_LAUNCH_CALLER.QUOTE_MODAL,
          undefined,
          undefined,
          componentdata
        )
        if (quoteDialog) {
          quoteDialog.pipe(take(1)).subscribe((value) => {})
          this.launchDialogService.dialogClose.subscribe((value) => {})
        }

        this.quoteCartFacade.loadCart();
      })
    }
  }

  getQuote() {
    let count = 0
    if (this.selectedQuote.length == 0) {
      this.showWarning = true
      window.scrollTo(0, 0)
      setTimeout(
        function () {
          this.showWarning = false
          this.showSuccess = false
        }.bind(this),
        5000
      )
    } else {
      for (let i = 0; i < this.selectedQuote.length; i++) {
        // if (this.selectedQuote[i].bomSellabilityFlag) {
        this.selectedQuote[i].reasonForQuote = this.reasonForQuotes[0].code
        // } else {
        //   this.selectedQuote[i].reasonForQuote = this.reasonForQuotes[0].name;
        // }
        const submitObj = {
          brandName: this.selectedQuote[i].brandName,
          brandCode: this.selectedQuote[i].brandCode,
          comment: '',
          customerRequestedDate: this.selectedQuote[i].customerRequestedDate,
          rfqPartDescription: this.selectedQuote[i].description,
          rfqPartNumber: this.selectedQuote[i].partNumber,
          productType: 'Part',
          quantity: this.selectedQuote[i].quantity,
          reasonForQuote: this.selectedQuote[i].reasonForQuote,
          serialNumber: this.serialNo,
        }

        if(submitObj.customerRequestedDate){
          this.quoteEntrie.push(submitObj);
        }
      }

      if(this.quoteEntrie.length === this.selectedQuote.length){
        this.spinnerOverlayService.show();
        this.welcomePackageService
        .addItemToQuote({ quoteEntryList: this.quoteEntrie })
        .subscribe((res) => {
          sessionStorage.setItem('cartStatus-current', 'added')
          for (let i = 0; i < this.selectedQuote.length; i++) {
            this.selectedQuote[i].selected = false
            this.client.indeterminated = false
            this.client.checked = false
          }
          this.selectedQuote = []
          this.quoteEntrie = []
          const componentdata = {}
          this.spinnerOverlayService.hide();
          const quoteDialog = this.launchDialogService.openDialog(
            VS_LAUNCH_CALLER.QUOTE_MODAL,
            undefined,
            undefined,
            componentdata
          )
          if (quoteDialog) {
            quoteDialog.pipe(take(1)).subscribe((value) => {})
            this.launchDialogService.dialogClose.subscribe((value) => {})
          }

          this.quoteCartFacade.loadCart();
        })
      } else{
        this.globalMessageService.add(
          { key: 'welcomePackage.selectAllCRDErrMsg' },
          GlobalMessageType.MSG_TYPE_ERROR,
          7000
        )
        window.scrollTo(0, 0);
      }
      
    }
  }
  onMasterClick(cliente: any, event) {
    this.isMasterSel = event.target.checked
    cliente.checked = event.target.checked
    cliente.indeterminated = false
    for (var i = 0; i < this.dataSource.length; i++) {
      this.dataSource[i].selected = this.isMasterSel
      this.selectedQuote.push(this.dataSource[i])
    }
    if (!event.target.checked) {
      this.selectedQuote = []
    }
  }
  keyDown(event, element) {
    if (event.which === 69) {
      event.preventDefault()
    }
  }
  onBlur(element) {
    if (element.quantity == '0' || element.quantity == null) {
      element.quantity = '1'
    }
  }
  preventE(event, element) {
    let value = element.quantity
    if (value > 999) {
      element.quantity = '9999'
      event.preventDefault()
    }
    if (event.which === 101 || event.which === 69) {
      event.preventDefault()
    }
  }

  checkUserEnabled(flagName) {
    return this.userRoleService.checkUserRoleEnabled(flagName)
  }
  loadMoreOrders() {
    if (this.isLoadMoreInProgress) {
      return
    }
    if (this.currentlyLoading) {
      return
    }

    this.currentlyLoading = true

    let crntPage = this.crntPage
    crntPage++
    if (crntPage <= this.totalPages - 1) {
      //check if current page is equal to the last page then dnt make a call
      this.welcomePackageService
        .getBomDetails(crntPage, this.PAGE_SIZE)
        .subscribe(
          (res: any) => {
            if (res !== null && res !== undefined) {
              this.isLoadMoreInProgress = false
              if (res.pagination !== undefined) {
                this.crntPage = res.pagination.currentPage
                this.totalPages = res.pagination.totalPages
                this.totalResult = res.pagination.totalResults
              } else {
                this.crntPage = 0
                this.totalPages = 0
                this.totalResult = 0
              }

              if (
                res.serialNumberBOMSearchList &&
                res.serialNumberBOMSearchList.length
              ) {
                this.dataSource = this.dataSource.concat(
                  res.serialNumberBOMSearchList
                )
                for (let i = 0; i < this.dataSource.length; i++) {
                  this.dataSource[i]['quantity'] = this.dataSource[i]['bomQty']
                }
                this.selectedItem = res.serialNumberHeaderInfo
              }
              this.currentlyLoading = false
            } else {
              this.isLoadMoreInProgress = false
              this.currentlyLoading = false
              this.globalMessageService.add(
                { key: 'welcomePackage.issueInOrderList' },
                GlobalMessageType.MSG_TYPE_ERROR,
                5000
              )
              window.scrollTo(0, 0)
            }
          },
          (err) => {
            this.isLoadMoreInProgress = false
            this.currentlyLoading = false
            this.globalMessageService.add(
              { key: 'welcomePackage.issueInOrderList' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
    } else {
      this.isLoadMoreInProgress = false
      this.currentlyLoading = false
    }
  }
}
//const tableData: Element[] = [];
